"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sport = exports.luxury = exports.exotic = exports.popularMake = void 0;
exports.popularMake = [
    'Acura',
    'Audi',
    'BMW',
    'Buick',
    'Cadillac',
    'Chevrolet',
    'Chrysler',
    'Dodge',
    'Ferrari',
    'Ford',
    'FIAT',
    'Genesis',
    'GMC',
    'Honda',
    'Hyundai',
    'INFINITI',
    'Jaguar',
    'Jeep',
    'Kia',
    'Land Rover',
    'Lexus',
    'Lincoln',
    'Mazda',
    'Mercedes-Benz',
    'MINI',
    'Mitsubishi',
    'Nissan',
    'Porsche',
    'Ram',
    'Rivian',
    'Subaru',
    'Tesla',
    'Toyota',
    'Volkswagen',
    'Volvo'
];
exports.exotic = [
    { make: 'Aston Martin' },
    { make: 'Audi', models: ['R8'] },
    { make: 'Bentley' },
    { make: 'Bughatti' },
    { make: 'Chevrolet', models: ['Z06', 'ZR-1'] },
    { make: 'Dodge', models: ['Viper'] },
    { make: 'Ferrari' },
    { make: 'Ford', models: ['GT'] },
    { make: 'Koengsegg' },
    { make: 'Lamborghini' },
    { make: 'Lexus', models: ['LFA'] },
    { make: 'Maserati', models: ['MC20'] },
    { make: 'McLaren' },
    { make: 'Mercedes-Benz', models: ['SLR', 'SLS AMG'] },
    { make: 'Pagani' },
    { make: 'Panoz' },
    { make: 'Porsche', models: ['918 Spyder', 'Carrera GT'] },
    { make: 'Rolls-Royce' },
    { make: 'Toyota', models: ['Supra', '2000GT'] },
];
exports.luxury = [
    { make: 'Audi' },
    { make: 'BMW' },
    { make: 'FIAT', models: ['124 Spider'] },
    { make: 'Ferrari' },
    { make: 'Jaguar' },
    { make: 'Land Rover' },
    { make: 'Lexus' },
    { make: 'Mercedes-Benz' },
    { make: 'Porsche' },
    { make: 'Volvo' },
    { make: 'Alfa Romeo' },
    { make: 'Aston Martin' },
    { make: 'Lamborghini' },
    { make: 'Lotus' },
    { make: 'Maserati' },
    { make: 'McLaren' },
    { make: 'Panoz' },
];
exports.sport = [];
